const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")   // special chars hatao
    .replace(/\s+/g, "-")           // space → hyphen
    .replace(/-+/g, "-");           // multiple hyphen → single
};

export default slugify;
